export default "__VITE_ASSET__CBa66apm__"